"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChainLinkFundDialog = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const wagmi_1 = require("wagmi");
const react_hooks_eth_1 = require("@dzambalaorg/react-hooks-eth");
const mui_inputs_core_1 = require("@dzambalaorg/mui-inputs-core");
const exchange_1 = require("@framework/exchange");
const types_1 = require("@framework/types");
const balanceOf_json_1 = __importDefault(require("@framework/abis/json/ERC20Simple/balanceOf.json"));
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const amount_1 = require("../inputs/amount");
const ChainLinkFundDialog = () => {
    const { writeContractAsync } = (0, react_hooks_eth_1.useWriteContractWithSimulation)();
    const { address } = (0, wagmi_1.useAccount)();
    const getAccountBalance = (0, react_hooks_eth_1.useSystemContract)(async (_decimals, systemContract) => {
        // https://docs.chain.link/docs/link-token-contracts/
        const value = await writeContractAsync({
            address: systemContract.parameters.linkAddress.toString(),
            abi: balanceOf_json_1.default,
            functionName: "balanceOf",
            args: [address],
        });
        const modValue = (BigInt(value) % 10n ** 14n).toString();
        return (0, exchange_1.formatEther)(modValue, _decimals, "LINK ");
    }, { success: false });
    const { execute: metaFnBalanceData } = (0, react_hooks_eth_1.useMetamaskValue)((values) => {
        return getAccountBalance(types_1.SystemModuleType.CHAIN_LINK, values);
    });
    return ((0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: [2], children: [(0, jsx_runtime_1.jsx)(mui_inputs_core_1.TextInput, { name: "subscriptionId" }), (0, jsx_runtime_1.jsx)(amount_1.AmountInput, { symbol: "LINK ", decimals: 18, getCurrentBalance: metaFnBalanceData })] }));
};
exports.ChainLinkFundDialog = ChainLinkFundDialog;
//# sourceMappingURL=index.js.map